import { takeEvery, call, put } from 'redux-saga/effects'
import { SagaIterator } from 'redux-saga'
import { store } from '../root/index'
import { LoadFormAction, loadedFormFromDisk, removeFormFromDisk, loadForm } from './actions'
import { fetchForm, LoadFormFromNetworkResult, FormRequestParams } from '../api/actions'
import { Form } from 'mytours-read-api-typescript'
import { getConfiguration } from '../configuration'

/**
 * Triggers the loading of a form
 * @param action contains the id of form to load
 */
function* handleLoadForm(action: LoadFormAction): SagaIterator {
	const { id, version, language } = action.payload
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	const form: Form | undefined = yield call(getConfiguration().loadFormFromDisk, projectId, id, version, language)
	if (form) {
		yield put(loadedFormFromDisk({ id, version, form }))
	} else {
		const params: FormRequestParams = {
			id: id,
			version: version,
			language,
			isPreCaching: false,
		}
		yield put(fetchForm.started(params))
	}
}

/**
 * After a successful request to fetch a form we want to store the result to disk so that we do not need to hit the network again (unless the item version changes).
 * @param action contains the form retrieved from network response
 */
function* handleLoadedFormFromNetwork(action: LoadFormFromNetworkResult): SagaIterator {
	const { id, version, language } = action.payload.params
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	try {
		yield call(getConfiguration().removeFormFromDisk, projectId, id, language)
	} catch (error) {
		// Error deleting old data
	}

	try {
		yield call(getConfiguration().saveFormToDisk, projectId, id, version, language, action.payload.result)
	} catch (error) {
		// Error saving data
	}
}

/**
 * Handles removing a form from disk
 * @param action contains the id of form to remove
 */
function* handleRemovingFormFromDisk(action: LoadFormAction): SagaIterator {
	const { id, language } = action.payload
	const state = store.getState()
	const projectId = state.settings.appInfo.projectId

	try {
		yield call(getConfiguration().removeFormFromDisk, projectId, id, language)
	} catch (error) {
		// Error deleting old data
	}
}

export default function*(): SagaIterator {
	yield takeEvery(loadForm, handleLoadForm)
	yield takeEvery(fetchForm.done, handleLoadedFormFromNetwork)
	yield takeEvery(removeFormFromDisk, handleRemovingFormFromDisk)
}
